import { Drawer } from 'vaul';
import React from 'react';
import content from 'constants/texts';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as PhoneIcon } from 'assets/icons/phone.svg';
import { useWindowSize } from '@uidotdev/usehooks';
import PropTypes from 'prop-types';

export default function ContactDrawer(props) {
  const { children } = props;
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const size = useWindowSize();

  return (
    <Drawer.Root
      open={openDrawer}
      direction={size.width < 768 ? 'bottom' : 'right'}
    >
      <Drawer.Trigger onClick={setOpenDrawer} asChild>
        {children}
      </Drawer.Trigger>

      <Drawer.Portal>
        <Drawer.Overlay
          className="fixed inset-0 bg-black/40 z-[2147483645]"
          onClick={() => setOpenDrawer(false)}
        />

        <Drawer.Content className="left-0 right-0 bottom-0 h-[auto] fixed outline-none flex z-[2147483646] font-[fieldwork-geo] md:w-[430px] md:left-auto md:top-0">
          <div className="bg-white w-full grow p-5 flex flex-col space-y-4  rounded-t-l-[16px] rounded-t-r-[16px]">
            <div className="max-w-md mx-auto">
              {/* Title */}
              <div>
                <div className="flex items-center justify-between">
                  <Drawer.Title className="font-medium text-gray-700 m-0">
                    {content.title}
                  </Drawer.Title>

                  <button
                    onClick={() => setOpenDrawer(false)}
                    className="flex items-center bg-transparent justify-center border-none outline-none m-0 h-6 w-6 p-0 text-gray-500 hover:text-gray-900 hover:bg-gray-100 cursor-pointer rounded-full"
                  >
                    <CloseIcon height={18} width={18} />
                  </button>
                </div>

                <Drawer.Description className="text-zinc-700">
                  {content.description}
                </Drawer.Description>
              </div>

              <div className="flex flex-col rounded-md bg-[#FAF8F8] p-4 md:p-6">
                <h4 className="m-0 font-medium">{content.contact.title}</h4>
                <div className="flex flex-row items-center justify-center space-x-4">
                  <span className="text-sm whitespace-nowrap px-2 py-1 rounded-md bg-green-100 border-solid border-[1px] border-green-700 text-green-900 font-normal">
                    {content.contact.tag}
                  </span>
                  <p className="text-sm">{content.contact.description}</p>
                </div>

                <a
                  className="button main no-underline"
                  href={`tel:${content.tel}`}
                >
                  <PhoneIcon height={24} width={24} />
                  <span className="font-[fieldwork-geo]">{content.tel}</span>
                </a>
              </div>
            </div>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}

ContactDrawer.propTypes = {
  children: PropTypes.node.isRequired,
};
